import CellCheckbox from './TableCells/CellCheckBox/CellCheckBox'
import HeaderCheckbox from './TableCells/HeaderCheckBox/HeaderCheckBox'

export const selectTag = 'selection'

export const selectableColumn = {
  id: selectTag,
  Header: HeaderCheckbox,
  Cell: CellCheckbox,
}
export const shouldShowCheckBox = (column, isSelectable) =>
  (column.id === selectTag && isSelectable) || column.id !== selectTag
